import { call } from '../@';

const getUsers = async () => await call('user-getList', {});

export default getUsers;
